interface UpdateItem {
  date: string;
  title: string;
  desc: string;
  type: 'new' | 'update' | 'hot';
}

const updates: UpdateItem[] = [
  { date: '2024.07.31', title: '《庆余年第三季》大结局上线', desc: '全集已同步至桔子视频，西瓜视频和丝瓜视频双源可选。', type: 'hot' },
  { date: '2024.07.30', title: '《长相思2》更新至第32集', desc: '最新剧情反转不断，三界大战一触即发，速来围观。', type: 'hot' },
  { date: '2024.07.29', title: '纪录片专区新增《蓝色星球》全系列', desc: 'BBC经典自然纪录大片，4K超清画质震撼呈现。', type: 'new' },
  { date: '2024.07.28', title: '国漫剧场《斗破苍穹》年番更新', desc: '最新一集萧炎突破斗宗强者，特效炸裂不容错过。', type: 'update' },
  { date: '2024.07.27', title: '《墨雨云间》播放量突破50亿', desc: '全网热议古装悬疑神作，吴谨言演技获赞。', type: 'hot' },
  { date: '2024.07.26', title: '站点加速节点升级完成', desc: '全国新增12个加速节点，播放速度提升40%。', type: 'update' },
  { date: '2024.07.25', title: '综艺专区《奔跑吧》最新季上线', desc: '全新嘉宾阵容，爆笑游戏体验，周末放松首选。', type: 'new' },
  { date: '2024.07.24', title: '《承欢记》口碑持续飙升', desc: '杨紫、许凯主演都市家庭剧，引发网友热议讨论。', type: 'update' },
];

const typeStyles: Record<string, { dot: string; label: string }> = {
  new: { dot: 'bg-primary-500', label: '上新' },
  update: { dot: 'bg-secondary-500', label: '更新' },
  hot: { dot: 'bg-accent-500', label: '热门' },
};

export default function Updates() {
  return (
    <section id="updates" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 bg-secondary-100 text-secondary-700 text-xs font-semibold rounded-full uppercase tracking-wide">
            最新动态
          </span>
          <h2 className="mt-4 text-2xl md:text-3xl font-bold text-foreground-950">桔子视频 · 实时更新日志</h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">
            每日剧集更新、站点动态，一网打尽不遗漏。
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-5 md:left-6 top-0 bottom-0 w-px bg-background-300"></div>
          <div className="space-y-6">
            {updates.map((item, i) => {
              const style = typeStyles[item.type];
              return (
                <div key={i} className="relative flex gap-5 md:gap-6 pl-1">
                  <div className={`relative z-10 w-3 h-3 md:w-3.5 md:h-3.5 rounded-full ${style.dot} mt-1.5 shrink-0 ring-4 ring-background-100`}></div>
                  <div className="flex-1 bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/60 hover:border-primary-300/30 transition-colors duration-150 cursor-pointer">
                    <div className="flex items-center gap-2 mb-1.5">
                      <span className="text-xs text-foreground-400 font-medium">{item.date}</span>
                      <span className={`text-[10px] font-semibold px-1.5 py-0.5 rounded ${style.dot} text-background-50 whitespace-nowrap`}>
                        {style.label}
                      </span>
                    </div>
                    <h3 className="text-sm md:text-base font-bold text-foreground-950">{item.title}</h3>
                    <p className="mt-1 text-xs md:text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}